import rawRoutes from 'campus/router/routes';
import { CAMPUS_PREFIX } from 'campus/campus-base';

/**
 * Публичный префикс Кампуса. Единственный источник правды: от него производны
 * проверки в campus/guard.js и граница зоны в src/router/rules/campus.js.
 *
 * По умолчанию `/campus` — совпадает с build.publicPath прежней отдельной
 * сборки, поэтому письма, СМС и ссылки из админки (campus.service.js,
 * /campus/login, /campus/register) продолжают вести куда надо. На партнёрских
 * доменах значение приходит из мета-тега, см. campus/campus-base.js.
 */
export { CAMPUS_PREFIX };

/**
 * Единственная точка, через которую админка обращается к модулю Кампуса.
 *
 * В отдельной сборке префикс давал vueRouterBase, а сами роуты объявлялись от
 * корня ('/rep-info', '/login', '/external/org'). В общем роутере база равна '/',
 * поэтому без префикса Кампус занял бы корень и начал конкурировать с
 * catchAll админки — в том числе одинаковым '/:catchAll(.*)*'.
 *
 * Префикс навешивается программно, чтобы campus/router/routes.js оставался
 * побайтово сверяемым с эталонным репозиторием.
 */
function prefixPath (path) {
    if (typeof path !== 'string' || !path.startsWith('/')) {
        return path;
    }

    return path === '/' ? CAMPUS_PREFIX : `${CAMPUS_PREFIX}${path}`;
}

function prefixRoute (route) {
    const prefixed = { ...route, path: prefixPath(route.path) };

    if (Array.isArray(route.children)) {
        prefixed.children = route.children.map(prefixRoute);
    }

    return prefixed;
}

export default rawRoutes.map(prefixRoute);
